'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Drawer = require('./Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Drawer2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-drawer/build/index.js
// module id = 83
// module chunks = 0